import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAdminAuth } from "@/lib/auth";
import { TID } from "@/lib/testIds";
import { formatErr } from "@/lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAdminAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      setErr(formatErr(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bls-admin flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-1">
            <span className="font-display text-3xl font-bold text-white">bles</span>
            <span className="font-display text-3xl font-bold text-[#7f77dd]">co</span>
          </div>
          <p className="mt-2 text-white/50 text-sm">Admin Console</p>
        </div>
        <form onSubmit={submit} className="bls-admin-card p-8 space-y-5">
          <div>
            <label className="text-xs uppercase tracking-wider text-white/50 font-medium">Email</label>
            <input
              type="email"
              autoFocus
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bls-admin-input mt-2"
              data-testid={TID.adminLoginEmail}
              placeholder="admin@blesco.in"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-white/50 font-medium">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bls-admin-input mt-2"
              data-testid={TID.adminLoginPassword}
              placeholder="••••••••"
            />
          </div>
          {err && <p className="text-sm text-red-400" data-testid="admin-login-error">{err}</p>}
          <button
            type="submit"
            disabled={busy}
            className="bls-admin-btn w-full disabled:opacity-50"
            data-testid={TID.adminLoginSubmit}
          >
            <Lock className="w-4 h-4" /> {busy ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-xs text-white/40 text-center">Single store admin · JWT secured</p>
        </form>
      </div>
    </div>
  );
}
